import { AnyComparator } from 'modules/queryBuilder/types';
import { SelectOption } from 'modules/queryBuilder/contexts';

export const isInvalidComparatorFromOptions = (
  comparator: AnyComparator | null,
  options: SelectOption<string>[] = [],
) => {
  return !options.find(({ value }) => value === comparator);
};
